import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { formatDate } from 'utilities/common';

import { currencyFormat } from 'utilities/common';

const Table = ({ data }) => {
  if (!data) {
    return (
      <div className="row">
        <div className="empty col-lg-12 truck">
          <div className="truck-wrapper">
            <div className="truck">
              <div className="truck-container"></div>
              <div className="glases"></div>
              <div className="bonet"></div>
              <div className="base"></div>
              <div className="base-aux"></div>
              <div className="wheel-back"></div>
              <div className="wheel-front"></div>
              <div className="smoke"></div>
            </div>
          </div>
          <p className="empty-title">Monitoring not found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="table-responsive m-0 table-overflow">
      <table
        className="table table-vcenter card-table datatable border-bottom"
        width="100%"
      >
        <thead>
          <tr>
            <th
              className="text-start border-end"
              style={{ whiteSpace: 'initial', width: '15%' }}
            >
              Client
            </th>
            <th
              className="text-start border-end"
              style={{ whiteSpace: 'initial', width: '15%' }}
            >
              Project
            </th>
            <th
              className="text-start border-end text-center"
              style={{ whiteSpace: 'initial', width: '5%' }}
            >
              Bulan Mulai
            </th>
            <th
              className="text-start border-end text-center"
              style={{ whiteSpace: 'initial', width: '5%' }}
            >
              Bulan Akhir
            </th>
            {data?.labels?.map((d, i) => (
              <th key={i} className="text-center border-end">
                {d}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white graph">
          {data?.projects?.map((d, i) => (
            <tr key={`${i}-${i}-${i}`}>
              <td style={{ width: '15%' }} className="border-end">
                <div className="table-col">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {d?.project?.customer.name}
                  </div>
                  <small className="info text-uppercase">
                    {d?.project?.customer.company_name}
                  </small>
                </div>
              </td>
              <td style={{ width: '15%' }} className="border-end">
                <div className="table-col">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {d?.project?.name}
                  </div>
                </div>
              </td>
              <td style={{ width: '5%' }} className="border-end text-center">
                {formatDate(d?.project?.start_monthly, 'YYYYMM')}
              </td>
              <td style={{ width: '5%' }} className="border-end text-center">
                {formatDate(d?.project?.end_monthly, 'YYYYMM')}
              </td>
              {d?.datas?.map((s, ii) => (
                <>
                  <td
                    key={`${i}-${ii}`}
                    className={`text-center border-end
                        ${s?.bg_color !== 'bg-black' ? 'text-white' : ''} ${
                      s?.bg_color
                    }`}
                  >
                    <OverlayTrigger
                      key="top"
                      placement="top"
                      overlay={
                        <Tooltip id={`tooltip-top`}>Total Receivable</Tooltip>
                      }
                    >
                      <div>{currencyFormat(s?.total)}</div>
                    </OverlayTrigger>
                  </td>
                </>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
